import React, { createContext, useContext, useEffect, useState } from "react";

const ScheduleConfigContext = createContext({
  loading: true,
  error: null,
  solution: null,
});

export const ScheduleConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({
    loading: true,
    error: null,
    solution: null,
  });

  useEffect(() => {
    let active = true;

    fetch("/api/scheduleConfig", { cache: "no-store" })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Unable to load schedule settings (${response.status}).`
          );
        }
        return response.json();
      })
      .then(({ solution }) => {
        if (!Number.isInteger(solution) || solution < 0 || solution > 20) {
          throw new Error(
            "NCBB_SCHEDULE_SOLUTION must be a number from 0 to 20."
          );
        }
        if (active) setConfig({ loading: false, error: null, solution });
      })
      .catch((error) => {
        if (active) setConfig({ loading: false, error, solution: null });
      });

    return () => {
      active = false;
    };
  }, []);

  return (
    <ScheduleConfigContext.Provider value={config}>
      {children}
    </ScheduleConfigContext.Provider>
  );
};

export const useScheduleConfig = () => useContext(ScheduleConfigContext);
